const generateRandomArray = (num) => Array.from({ length: num }, (_, index) => index + 1);

const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
};

export const getShuffledArray = (num) => {
  const randomArray = generateRandomArray(num);
  const shuffledArray = shuffleArray(randomArray);

  return shuffledArray;
};

// const bingo = getShuffledArray(50).slice(0, 25);

// console.log('bingo row length', Math.sqrt(bingo.length));
// console.log('bingo', bingo, '\nlength', bingo.length);
